import { createAction } from '@reduxjs/toolkit';
export const FETCH_CALL_ASSISTANT_QUOTA = 'FETCH_CALL_ASSISTANT_QUOTA';
export const fetchCallAssistantQuotaAction = createAction(FETCH_CALL_ASSISTANT_QUOTA);